
const initialState = {
    pricingValuePending: false,
    pricingValueFetched: false,
    pricingValueData: null,
    pricingValueErorr: null,
    createPricingValuePending: false,
    createPricingValueFetched: false,
    createPricingValueData: null,
    createPricingValueErorr: null
}

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case 'GET_PRICING_VALUE_PENDING': {
            state = Object.assign({}, state, { pricingValuePending: true, pricingValueFetched: false });
            break;
        }
        case 'GET_PRICING_VALUE_FULFILLED': {
            state = Object.assign({}, state, { pricingValuePending: false, pricingValueFetched: true, pricingValueData: action.data });
            break;
        }
        case 'GET_PRICING_VALUE_REJECTED': {
            state = Object.assign({}, state, { pricingValuePending: false,  pricingValueFetched: false, pricingValueData: null, pricingValueErorr: action.error });
            break;
        }
        case 'CREATE_PRICING_VALUE_PENDING': {
            state = Object.assign({}, state, { createPricingValuePending: true, createPricingValueFetched: false });
            break;
        }
        case 'CREATE_PRICING_VALUE_FULFILLED': {
            state = Object.assign({}, state, { createPricingValuePending: false, createPricingValueFetched: true, createPricingValueData: action.data });
            break;
        }
        case 'CREATE_PRICING_VALUE_REJECTED': {
            state = Object.assign({}, state, { createPricingValuePending: false,  createPricingValueFetched: false, createPricingValueData: null, createPricingValueErorr: action.error });
            break;
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/pricingValueReducer.jsx